/**
 * DO NOT MANUAL MODIFY THIS FILE
 *
 * AUTO GENERATED
 */
import { Ref, SVGProps, forwardRef } from 'react';
import classNames from 'classnames';
import { ICON_CLASS } from '../../../utils/constants';
import * as Styled from '../Icon.styles';
const EditTableSolidBase = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="#404040" width="1em" height="1em" ref={ref} {...props}><path fillRule="evenodd" clipRule="evenodd" d="M3 5a2 2 0 0 1 2-2h13a2 2 0 0 1 2 2v2H3V5Zm0 3h5v12H5a2 2 0 0 1-2-2V8Zm11 0H9v10.966l.242-.54c.15-.335.359-.64.618-.899L14 13.385V8Zm6 0v.035a2.489 2.489 0 0 0-1.35.697L15 12.385V8h5Zm.064 2.145a.5.5 0 0 1 .707 0l1.084 1.085a.5.5 0 0 1 0 .707l-1.069 1.068-1.791-1.791 1.069-1.069Zm.01 3.573-1.79-1.792-7.011 7.014a1.004 1.004 0 0 0-.207.3l-1.057 2.365-.001.005a.32.32 0 0 0 .386.38l2.368-1.05c.113-.05.216-.121.303-.209l7.01-7.013Z" /></svg>);
const EditTableSolid = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(({
  className,
  ...rest
}: SVGProps<SVGSVGElement> & {
  className?: string;
}, ref) => <Styled.Icon className={classNames(ICON_CLASS, className)} as={EditTableSolidBase} {...rest} ref={ref} />);
export default EditTableSolid;